(ns manage.content-variant-page.view.core
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Fade$default" :as Fade]
            ["@mui/material/Stack$default" :as Stack]
            ["src/svg/artwork/folder.svg$default" :as FolderArtwork]
            ["src/svg/controls/watch.svg$default" :as Watch]
            [common.patterns.empty-state-view :refer [empty-state-view]]
            [common.patterns.feed-import :as feed-patterns]
            [common.queries :refer [use-query]]
            [common.resource.query.adset :as adset-queries]
            [common.url-template :as url-tpl]
            [common.util :as util]
            [common.widgets.page :as page]
            [linked.core :as l]
            [manage.adset.hooks :refer [use-channel]]
            [manage.adset.view.page-header :as adset-page-header]
            [manage.campaign-tags-page.view :refer [campaign-tags-page
                                                    use-campaign-tags-page-props]]
            [manage.content-configuration-page.view.core :refer [export-tab
                                                                 templates-tab]]
            [manage.content-configuration-page.view.import :refer [import-failure
                                                                   import-pending]]
            [manage.content-variant-page.queries :as q]
            [manage.content-variant-page.view.import-warnings :refer [import-warnings]]
            [manage.content-variant-page.view.overview :as overview]
            [manage.variants-preview-page.view :refer [variants-preview-page]]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as rfe]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui open-feed-ocp-button []
  (let [adset (:value (use-subscribe [:resource.adset/one]))
        edit-allowed? (use-subscribe [:resource.user/allowed? "adsets2.edit"])]
    ($ Button {:disabled (not edit-allowed?)
               :variant "contained"
               :on-click #(rf/dispatch [:form.content-variant/open])}
       (if (:feedId adset) "Edit configuration" "Import data sheet"))))

(defui preview-button []
  (let [preview-href (use-subscribe [:table.content-variants/preview-route-url])]
    ($ Button
       {:variant "contained"
        :href preview-href
        :startIcon ($ Watch)}
       "Preview")))

(defui buttons []
  (let [field-classes-configured? (use-subscribe [:resource.feed-importers/field-classes-configured?])]
    ($ Stack
       {:direction "row"
        :spacing 1
        :alignItems "center"
        :justifyContent "flex-end"
        :sx #js {:py 1}}
       (when field-classes-configured?
         ($ feed-patterns/import-status-with-refresh))
       ($ open-feed-ocp-button)
       (when field-classes-configured?
         ($ preview-button)))))

(defui empty-view-feed [{:keys [docs-href]}]
  ($ empty-state-view
     {:title "Import feed"
      :description "Effortlessly import content sheets with text, images, and media.
                    Let's upload and enhance your ads! 📄🔍"
      :artwork FolderArtwork
      :docs-href docs-href
      :actions ($ open-feed-ocp-button)}))

(defui empty-view-field-classes [{:keys [docs-href]}]
  ($ empty-state-view
     {:title "Classify feed columns"
      :description "Continue configuring your feed by classifying its columns to ensure
                    you can effectively set up targeting and serve your variants. 🏗️"
      :artwork FolderArtwork
      :docs-href docs-href
      :actions ($ open-feed-ocp-button)}))

(defui content []
  (let [url-context (use-subscribe [:url-context])
        import-status (use-subscribe [:page.content-variant/import-status])
        has-feed? (use-subscribe [:resource.adset/has-feed?])
        field-classes-configured? (use-subscribe [:resource.feed-importers/field-classes-configured?])

        docs-href (url-tpl/render :docs/article (assoc url-context :slug "24177250673180-Build-Content-Variants"))]
    (case import-status
      :success (cond
                 (not has-feed?) ($ empty-view-feed {:docs-href docs-href})
                 (not field-classes-configured?) ($ empty-view-field-classes {:docs-href docs-href})
                 :else ($ overview/view))

      :failure ($ page/content-padding
                  ($ import-failure))

      ($ import-pending))))

(defui content-tab []
  (let [{:keys [advertiser-id adset-id]} (use-subscribe [:url-context])
        {{feed-id :feedId} :data} (use-query (adset-queries/adset-query {:adset-id adset-id}))
        {{{import-state :state import-id :id} :data} :data} (use-query (q/latest-feed-import-status-query advertiser-id feed-id))
        is-import-running? (= import-state "running")
        {{feed-errors-stats :data} :data} (use-query (q/latest-feed-import-errors-query advertiser-id feed-id import-id is-import-running?))
        os-enabled (use-subscribe [:common.os/enabled])]
    ($ Stack
       {:sx (util/spread-obj #js {:flex 1
                                  :overflow "hidden"}
                             (when os-enabled
                               page/wpp-os-content-padding-sx))}
       ($ Stack
          {:sx (when-not os-enabled #js {:px 3})}
          ($ buttons)
          ($ import-warnings {:isImportRunning is-import-running?
                              :importErrorsStats feed-errors-stats}))
       ($ content))))

(defn tabs [channel]
  (cond-> (l/map :template {:label "Templates"
                            :view templates-tab}

                 :content {:label "Content"
                           :view content-tab})

    (= channel "display")
    (assoc :export {:label "Export"
                    :view export-tab})))

(defn content-variant-page [_]
  (let [url-context (use-subscribe [:url-context])
        channel (use-channel)
        tabs (tabs channel)

        view (use-subscribe [:router/handler-name])
        preview (= :adset/content-variants-preview view)
        close-preview (uix/use-callback
                       (fn []
                         ;; The preview forward-events need to be deregistered before navigating.
                         (rf/dispatch [:variants-preview.core/destroy])
                         (rfe/navigate :adset/content-variants {:path-params url-context
                                                                :fragment "content"}))
                       [url-context])]
    ($ :<>
       ($ page/page
          ($ adset-page-header/page-header
             {:tabs tabs})
          ($ page/active-tab
             {:tabs tabs
              :sx #js {:px 0 :pb 0 :overflow "hidden"}}))

       ($ campaign-tags-page (use-campaign-tags-page-props))

       ($ Fade
          {:in (boolean preview)
           :unmountOnExit true}
          ($ variants-preview-page {:onClose close-preview})))))
